/*
 * Globální scrollovací animace „ghosting inset" — prvky s třídou .ghostUp se při dorolování
 * vynoří zdola. Styly jsou v critical-css (.ghostUp / .js-anim .ghostUp / .is-in).
 *
 * NIKDY NESMÍ ZŮSTAT PRÁZDNÉ MÍSTO: skrývání zapíná až tenhle skript třídou `js-anim` na
 * <html>. Když se soubor nenačte, spadne na výjimku nebo prohlížeč neumí IntersectionObserver,
 * třída se nepřidá (nebo se odebere) a obsah je normálně vidět. Navíc pojistný timeout odhalí
 * všechno, co už je ve viewportu, kdyby observer z jakéhokoli důvodu nevystřelil.
 */
(function () {
	var SELEKTOR = '.ghostUp';
	var korenElement = document.documentElement;

	function odhalVse() {
		var prvky = document.querySelectorAll(SELEKTOR);
		for (var i = 0; i < prvky.length; i++) prvky[i].classList.add('is-in');
	}

	try {
		if (!('IntersectionObserver' in window)) { odhalVse(); return; }

		/* Signál pro inline pojistku v theme.liquid (ta přidává js-anim před prvním paintem
		   a bez tohoto flagu ji po 3 s zase odebere). */
		window.__sknrsAnimInit = true;
		korenElement.classList.add('js-anim');

		var observer = new IntersectionObserver(function (zaznamy) {
			for (var i = 0; i < zaznamy.length; i++) {
				if (!zaznamy[i].isIntersecting) continue;
				zaznamy[i].target.classList.add('is-in');
				observer.unobserve(zaznamy[i].target);
			}
		}, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

		function sleduj() {
			var prvky = document.querySelectorAll(SELEKTOR + ':not(.is-in)');
			for (var i = 0; i < prvky.length; i++) observer.observe(prvky[i]);
		}

		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sleduj);
		else sleduj();

		/* Pojistka: co je po 1,5 s ve viewportu a pořád skryté, odhal natvrdo. */
		setTimeout(function () {
			var prvky = document.querySelectorAll(SELEKTOR + ':not(.is-in)');
			for (var i = 0; i < prvky.length; i++) {
				if (prvky[i].getBoundingClientRect().top < window.innerHeight) prvky[i].classList.add('is-in');
			}
		}, 1500);

		/* Theme editor překresluje sekce za běhu. */
		document.addEventListener('shopify:section:load', sleduj);
	} catch (chyba) {
		korenElement.classList.remove('js-anim');
		odhalVse();
	}
})();
